import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ReadMore from '../../components/ReadMore';
import raisingTheBar from '../../../assets/images/raisingTheBar.jpeg';

const RaisingTheBar = ({ isMobile }) => {

  return (
    <Col>
      <Row>
        <Col>
        {/* @ADVISE - This is an h2 but feels like it should be an h3... */}
          <h2
            id="raising-the-bar-on-reliable-services"
            tabIndex="-1"
          >
            RAISING THE BAR ON RELIABLE SERVICES
          </h2>
        </Col>
      </Row>
      <Row style={{marginTop: 30}}>
        <Col xs={12} md={6} lg={8}>
          <p>
            CSIO members have always relied on CSIO for secure, trustworthy services. From MPOI, to CSIOnet and CSIO.com, we're a trusted source.
          </p>
          <p>
            While member surveys consistently show positive feedback, that hasn't stopped us from trying to take services to the next level.
          </p>
          <p>
            We want reliable, secure services members rely on to stay ahead of the curve so that the enhancements are always ready when they are.
          </p>
        </Col>
        <Col xs={12} md={6} lg={4} style={{
          backgroundImage: `url(${raisingTheBar})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}/>
      </Row>
      <Row>
        <Col>
          <ReadMore href="/raising-the-bar-on-reliable-services#top" />
        </Col>
      </Row>
    </Col>
  )
}

export default RaisingTheBar;
